<template>
  <div class="kd-panel">
    <div :class="headerClass">
      <slot name='header'>
        <div class="kd-panel-form__header_title">{{ title }}</div>
        <div class="kd-panel-form__header_subtitle">{{ subtitle }}</div>
      </slot>
    </div>
    <div class="kd-panel__content">
      <div class="kl-form">
        <slot></slot>
      </div>
    </div>
    <div class="kd-panel__footer--full w-hr">
      <slot name='footer'></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "PanelForm",
  props: {
    title: {
      default: "Title"
    },
    subtitle: {
      defualt: "Subtitle"
    },
    headerClass: {
      default: 'kd-panel__header'
    }
  }
} 
</script>
